import React from 'react';
import LabeledValues from '../../components/LabeledValues';
import { ALL_RATES } from './constants';
import { useRateFilters } from './hooks';
import RateFilters from './RateFilters';

/**
 * What an expanded tariff row shows: its summary lines, then its rates, filtered by category and
 * search (scrolls when long). "All rates" adds a Category column.
 * @param {{ rows: { label: string, value: React.ReactNode, tone?: string }[], rates: Object[] }} props
 *   `rates` are display rows from `describeRates`
 */
const TariffDetails = ({ rows, rates }) => {
    const { categories, category, setCategory, setSearch, visibleRows } = useRateFilters(rates);
    const showCategory = category === ALL_RATES.key;

    return (
        <div className="flex min-w-0 flex-col gap-3">
            <LabeledValues rows={rows} />
            {rates.length === 0 ? (
                <span className="text-sm text-muted">No rates on this tariff.</span>
            ) : (
                <>
                    <RateFilters
                        categories={categories}
                        category={category}
                        onCategoryChange={setCategory}
                        onSearchChange={setSearch}
                    />
                    {visibleRows.length === 0 ? (
                        <span className="text-sm text-muted">No rates match your search.</span>
                    ) : (
                        <div className="max-h-72 overflow-y-auto rounded-md border border-border bg-surface">
                            <table className="w-full text-left text-sm">
                                <thead className="sticky top-0 bg-surface">
                                    <tr className="border-b border-border">
                                        {showCategory ? <th className="px-3 py-2 font-semibold">Category</th> : null}
                                        <th className="px-3 py-2 font-semibold">Rate</th>
                                        <th className="px-3 py-2 font-semibold">Range</th>
                                        <th className="px-3 py-2 text-right font-semibold">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleRows.map((row) => (
                                        <tr key={row.key} className="border-b border-border last:border-b-0">
                                            {showCategory ? (
                                                <td className="break-words px-3 py-2">{row.category.label}</td>
                                            ) : null}
                                            <td className="break-words px-3 py-2">{row.name}</td>
                                            <td className="px-3 py-2">{row.range}</td>
                                            <td className="px-3 py-2 text-right">{row.rate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default TariffDetails;
